var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pc-dialog',{attrs:{"title":"温馨提示","visible":_vm.dialogVisible},on:{"update:visible":function($event){_vm.dialogVisible=$event},"close":_vm.close,"confirm":_vm.close},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"tips"},[_c('span',[_vm._v(_vm._s(_vm.tips))])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }